import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hpsfir-card member" }

import { ref } from 'vue';
import MemberList from './memberlist/index.vue';
import LevelRule from './levelrule/index.vue';
import BenefitList from './benefitlist/index.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const activeTab = ref('memberList');

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      class: "member-tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "会员列表",
          name: "memberList"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'memberList')
              ? (_openBlock(), _createBlock(MemberList, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "会员等级规则",
          name: "levelRule"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'levelRule')
              ? (_openBlock(), _createBlock(LevelRule, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "会员权益列表",
          name: "benefitList"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'benefitList')
              ? (_openBlock(), _createBlock(BenefitList, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})